
import { CommonAxiosGet } from "./CommonAxios";
import { config } from "./CommonURLS";
import { store } from "../store";

export const UseGetStatus = () => {
    const { dispatch } = store
    const url = config.url.API_URL + `getcouresFlags`;
    CommonAxiosGet(url).then((res) => {
        if (res?.data?.scode === '01') {
            dispatch({ type: "Coursesflags", payload: res?.data?.couresFlags[0] });
        }
    });
};
